export default {
  GET_ALL: `#graphql
  query getTemporaryStocks($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getTemporaryStocks(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init:  $init, final: $final)
    { 
      docs {
        temporaryStock,
        stringStock,
        stringExistsTiers,
        stringExistsProducts,
        stringExistsSizes
      },
      totalDocs,
      limit,
      hasPrevPage,
      hasNextPage,
      page,
      totalPages,
      prevPage,
      nextPage,
      pagingCounter
    }            
  }`,

  GET_HISTORY: `#graphql
  query getTemporaryStocksHistory($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getTemporaryStocksHistory(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init:  $init, final: $final)
    { 
      docs {
        _id,
        version,
        temporaryStock,
        stringStock,
        stringExistsTiers,
        stringExistsProducts,
        stringExistsSizes,
        transaction,
        createdAt,
        createdBy,
        updatedBy
      },
      totalDocs,
      limit,
      hasPrevPage,
      hasNextPage,
      page,
      totalPages,
      prevPage,
      nextPage,
      pagingCounter
    }            
  }`,

  NEW: `#graphql
  mutation NewTemporaryStock($temporaryStock: TemporaryStockInput!) {
    newTemporaryStock(input: $temporaryStock)
    {
      temporaryStock,
      stringStock,
      stringExistsTiers,
      stringExistsProducts,
      stringExistsSizes
    }            
  }`,

  UPDATE: `#graphql
  mutation UpdateTemporaryStock($temporaryStock: String!, $temporaryStockUpdate: TemporaryStockUpdateInput!) {
    updateTemporaryStock(temporaryStock:$temporaryStock, temporaryStockUpdate: $temporaryStockUpdate)
    {
      temporaryStock
    }            
  }`,

  DELETE: `#graphql
  mutation DeleteTemporaryStock($temporaryStock: String!) {
    deleteTemporaryStock(temporaryStock:$temporaryStock)
    {
      temporaryStock
    }            
  }`
}



// WEBPACK FOOTER //
// ./src/graphql/temporaryStock.js